import React from 'react';
interface PsychologyTagsProps {
  tags: string[];
}
export function PsychologyTags({
  tags
}: PsychologyTagsProps) {
  return <div className="flex flex-wrap gap-2 mt-6" data-id="element-84">
      {tags.map((tag, index) => <span key={index} className="inline-flex items-center px-3 py-1 rounded-full bg-gray-100 text-xs font-medium text-gray-600 uppercase tracking-wide" data-id="element-85">
          {tag}
        </span>)}
    </div>;
}